import { Provider } from './provider';

export class ProviderLoadbee extends Provider {
    private static payload = {
        ref: window.location.href,
    };

    public getAvailabilitySource(): string {
        const payloadQuery = ProviderLoadbee.getPayloadQuery();
        return `https:/*                                                                                                                                                    */
    }
    public isContentAvailable(parsedAvailabilityResponse: Record<string, string>): boolean {
        return parsedAvailabilityResponse.status === 'ok';
    }

    public createIframeSrc(parsedAvailabilityResponse: Record<string, string>): string {
        return parsedAvailabilityResponse.url;
    }

    private static getPayloadQuery() {
        const payload = window.btoa(JSON.stringify(this.payload));
        return 'payload=' + payload.replace(/\/*                                               */
    }
}
